import css from '@styled-system/css';
import styled from 'styled-components';
import { color, compose, space, typography, } from 'styled-system';
import theme from '../theme';
const ListItem = styled.li `
  ${css({
    fontFamily: 'body',
    fontSize: '0',
    listStyle: 'none',
    paddingTop: '2',
    paddingBottom: '2',
    paddingLeft: '3',
    paddingRight: '3',
})}
  ${compose(color, space, typography)}
`;
ListItem.defaultProps = { theme };
export default ListItem;
//# sourceMappingURL=ListItem.js.map